module.exports = __webpack_public_path__ + "static/media/martini.ac43b184.jpg";